const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_gt2y9sbDB',
      userPoolClientId: '5spj0lt0p2u8qfgh3iqdpi10hl',
      loginWith: {
        oauth: {
          domain: 'us-east-1gt2y9sbdb.auth.us-east-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: ['https://order-entry.demandarc.com', 'https://staging-order-entry.demandarc.com', 'http://localhost:3000'],
          redirectSignOut: ['https://order-entry.demandarc.com', 'https://staging-order-entry.demandarc.com', 'http://localhost:3000'],
          responseType: 'code'
        }
      }
    }
  }
};

export default awsConfig;
